import { useQuery } from '@tanstack/react-query';
import { IStatsResponse } from "../../utils/types";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';


export const useFilterExtendedStats = (past: string) =>
  useQuery({
    queryKey: ["filter_extended_stats", past],
    queryFn: async (): Promise<IStatsResponse> => {
      const res = await apiClient.get(ENDPOINTS.DASHBOARD.FILTERED_STATS(past));
      return res.data;
    },
  });
